export const projectName = "Traces of Boxes";
export const contractAddress = "0x16033d983B2a3D8D80E66103e49bBBbDA7EfCF45";
export const opensea = "traces-of-boxes";
export const twitter = "TracesOfBoxes";
export const supply = 1111;
